export default {
      id: "attachment-usage",
      viewBox: "0 0 22 23",
      url: __webpack_public_path__ + "icons.svg#attachment",
      toString: function () {
        return this.url;
      }
    }